module.exports = __webpack_public_path__ + "img/sendloop.88f82214.png";